import React from "react";
import Calendly from "../../../components/Calendly/Calendly";
import Layout from "../../Layouts/Layout";

const CalendlyPage = ({}) => {
  return (
    <Layout>
      <Calendly />
    </Layout>
  );
};

export default CalendlyPage;
